module.exports = __webpack_public_path__ + "static/img/wooribank.6e62b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/etc/wooribank.png
// module id = pDp2
// module chunks = 1